import { render, staticRenderFns } from "./EditStoreType.vue?vue&type=template&id=38ca5477&scoped=true"
import script from "./EditStoreType.vue?vue&type=script&lang=js"
export * from "./EditStoreType.vue?vue&type=script&lang=js"
import style0 from "./EditStoreType.vue?vue&type=style&index=0&id=38ca5477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca5477",
  null
  
)

export default component.exports